import * as React from 'react';
import { temporaryConfig, time } from '../../../../model/room';
import ConfirmButton from '../../../../ui-components/Button/ConfirmButton';
import UndoButton from '../../../../ui-components/Button/UndoButton';
import { Grid, withStyles, StyledComponentProps, Typography, Divider } from '@material-ui/core';
import { styles } from './styles';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import HourPicker from '../../../../ui-components/HourPicker/HourPicker';
import NumericField from '../../../../ui-components/NumericField/NumericField';

interface IProps {
    onConfirm: (config: temporaryConfig) => any;
    onCancel: () => any;
}
const TemporaryConfigComp = (props: IProps & StyledComponentProps) => {
    const [date, setDate] = React.useState<Date>(new Date());
    const [from, setFrom] = React.useState<time>();
    const [to, setTo] = React.useState<time>();
    const [duration, setDuration] = React.useState<number>();
    const confirm = () => {
        const conf: temporaryConfig = {
            date,
            openingDetail: {
                openingTime: from,
                closingTime: to,
                duration: duration
            }
        }
        props.onConfirm(conf);
    }
    const saveEnabled = ()=>{
        return Boolean(from && to && date && duration);
    }
    return (
        <div style={{ minHeight: 400, minWidth: 400 }}>
            <Grid container style={{ padding: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Grid item sm={12} style={{display:'flex', justifyContent:'center'}}>
                    <Typography variant='h6'>Aggiungi un' apertura ridotta</Typography>
                </Grid>
                <Grid item sm={12}>
                    <DatePicker
                        key={`tempoararyConfig-date-picker`}
                        label="Giorno"
                        fullWidth
                        value={date}
                        onChange={(e) => setDate(e)}
                    />
                </Grid>
                <Grid item sm={12} className={props.classes.Input}>
                    <HourPicker
                        label="Apertura"
                        fullWidth
                        //name="sunday.closingTime"
                        value={from}
                        onChange={(h, m) => setFrom({ hours: h, minutes: m })}
                    />
                </Grid>
                <Grid item sm={12} className={props.classes.Input}>
                    <HourPicker
                        label="Chiusura"
                        fullWidth
                        value={to}
                        onChange={(h, m) => setTo({ hours: h, minutes: m })}
                    />
                </Grid>
                <Grid item sm={12} className={props.classes.Input}>
                <NumericField
                    label="Durata"
                    value={duration}
                    onChange={d => setDuration(d)}
                />
            </Grid>
            <Divider />
                <Grid item sm={12} className={props.classes.CalendarButtonsContainer}>
                    <ConfirmButton text='Conferma' onClick={confirm} disabled={!saveEnabled()}/>
                    <UndoButton text='Annulla' onClick={() => props.onCancel()} />
                </Grid>
            </Grid>
        </div>
    )
}

export const TemporaryConfig = withStyles(styles)(TemporaryConfigComp)